import { useEffect, useState } from "react";
import StepperDefault from '../../components/stepper';
import Testimonial from '../../components/testimonial';
import BasicDetails from './basicProfile'
import SkillDetails from './skills'
import Resume from './resume'
import AvailablityDetails from './availablity';
import ellowLogo from "../../assets/images/ellow-logo.png";
import Styles from "./styles.module.scss";
import { getAPI, putAPI } from "../../api/apis";
import { useLocation } from "react-router-dom";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import mixpanelData, { userProfile } from "../../utils/mixpanel";
import { REACT_APP_CANDIDATE } from "../../utils/common";

Auth.configure({
  userPoolId: "ap-south-1_xW3Zsub3t",
  userPoolWebClientId: "2jn6qgntppsud848ri333cud5s", // app client id
  region: "ap-south-1",
  oauth: {
    region: "ap-south-1",
    domain: "authmyworkplace.ellow.io",
    scope: ["phone", "email", "openid", "aws.cognito.signin.user.admin", "profile"],
    redirectSignIn: "https://myworkplace.ellow.io/login?provider=google",
    redirectSignOut: "https://myworkplace.ellow.io/login",
    responseType: "code" // or 'token', note that REFRESH token will only be generated when the responseType is code
  }
})


const items = [
  {
    label: "Personal Details",
    icon: "one",
  },
  {
    label: "Resume",
    icon: "two",
  },
  {
    label: "Skills",
    icon: "three",
  },
  {
    label: "Availability",
    icon: "four",
  }
];

const BasicProfile: React.FC = () => {

  // const [googleId, setGoogleId] = useState<string>('')
  const [step, setStep] = useState<number>(0)
  const [resume, setResume] = useState<string | null>(null)
  const [profileValues, setProfileValues] = useState<Array<{ profile_metadata: { firstName?: string, lastName?: string, email?: string, phone?: string ,city?: string, country?: string}, candidateId: string }>>([])
  const [skillValues, setSkillValues] = useState<{
    workExperience: number,
    jobRoles: { name: string, id: number }[],
    techStack: { experience: string; expertise: number; skill: { skillId: number; skillName: string; }; stackId: number; }[],
  }>({
    workExperience: 0,
    jobRoles: [],
    techStack: [{ experience: "", expertise: 0, skill: { skillId: 0, skillName: '' }, stackId: 0 }]
  })
  const [availablity, setAvailablity] = useState<{contractType: string,workType: string}>({contractType: '',workType: ''})

  const location = useLocation();
  let navigate = useNavigate();

  const { loginId }: any = location.state || localStorage.getItem('loginId') || ''
  let googleId: string = localStorage.getItem('loginId') || ''

  useEffect(() => {

    if (loginId) {
      getBasicProfileValues(loginId, {});      
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSubmit = (data: any) => {
      
    putAPI( REACT_APP_CANDIDATE + `/candidates`, data).then((response) => {
      if (response.error) {
        return
      }
      
      if (step < 3)
        setStep(step + 1)

      switch (step){
        case 0: 
        mixpanelData('MWP-Personal Details Submitt', {
          'distinct_id': response && response.data[0].profile_metadata.email ,
          'phoneNumber': response && response.data[0].profile_metadata.phoneNumber ,
          'Name': response && (response.data[0].profile_metadata.firstName + ' ' +  response.data[0].profile_metadata.lastName),
          'Email':response && response.data[0].profile_metadata.email,
        })
        mixpanelData('New MWP - Personal Details Submit', {
          'distinct_id': response && response.data[0].profile_metadata.email ,
          'Candidate loginid': loginId,
          'Phone': response && response.data[0].profile_metadata.phoneNumber ,
          'Name': response && (response.data[0].profile_metadata.firstName + ' ' +  response.data[0].profile_metadata.lastName),
          'Email':response && response.data[0].profile_metadata.email,
        })
        userProfile({
          '$phone': response && response.data[0].profile_metadata.phoneNumber ,
          '$name': response && (response.data[0].profile_metadata.firstName + ' ' +  response.data[0].profile_metadata.lastName),
          '$email':response && response.data[0].profile_metadata.email,
          'ellow status': 'F0 - Registered',
          'Sourced by': 'FREELANCER',
          'Source name': response && (response.data[0].profile_metadata.firstName + ' ' +  response.data[0].profile_metadata.lastName)
        },loginId)
          return
        case 2:
          const skills: {name: string, experience: string, expertise: number}[] = response && response.data[0].profile_metadata.techStack && response.data[0].profile_metadata.techStack.map((item: {skill: {skillId: number, skillName: string}, experience: string, expertise: number}) => { return (item.skill.skillName) })
          mixpanelData('MWP-Skills Submitt', {
            'distinct_id': response && response.data[0].profile_metadata.email,
            'workExperience': response && response.data[0].profile_metadata.workExperience,
            'Email':response && response.data[0].profile_metadata.email,
          })
          mixpanelData('New MWP - Skills Submit', {
            'distinct_id': response && response.data[0].profile_metadata.email,
            'Candidate loginid': loginId,
            'Skills': skills,
            'English proficiency' : response && response.data[0].profile_metadata.englishProficiency.proficiency,
            'Work experience': response && response.data[0].profile_metadata.workExperience
          })
          userProfile({
            'Skills': skills,
            'Work experience': response && response.data[0].profile_metadata.workExperience,
            '$email': response && response.data[0].profile_metadata.email
          }, loginId)
          return
        case 3:
          return
      }
    })
  }

  const updateStepper = () =>{
    setStep(step + 1)
    getBasicProfileValues(loginId ? loginId : googleId, {});
  }

  const Back = (data: any) => {
     
    if (data){
      if ( !data.profileMetadata.workExperience){
        data.profileMetadata.workExperience = 0
      }

      putAPI( REACT_APP_CANDIDATE + `/candidates`, data).then((response) => {
        if( response && response.status === 1){
          getBasicProfileValues(loginId ? loginId : googleId, {});
          setStep(step - 1)
        }
      })
    }else {
    getBasicProfileValues(loginId ? loginId : googleId, {});
    setStep(step - 1)
    }

  }

  const getBasicProfileValues = (id: string, values: {}) => {
    getAPI( REACT_APP_CANDIDATE + `/candidates/${id}`).then((response) => {

      if (response.data && response.data.length !== 0) {
        
        localStorage.setItem("profile_metadata", JSON.stringify(response.data[0].profile_metadata))
        localStorage.setItem("candidate_status", response.data[0].candidate_status)
 
        if (response && response.data[0].candidate_status === 2 && response.data[0].status) {   
              
          navigate("/dashboard", {
            state: {
              candidateStatus: response.data[0].candidate_status
            }
          });
        }
        const updatedDefaultValues = {
          ...response.data[0].profile_metadata,
          phoneNumber: response.data[0].profile_metadata.phoneNumber ? response.data[0].profile_metadata.phoneNumber.toString() : '91'
        } 
        setProfileValues(updatedDefaultValues)
        setResume(response.data[0].profile_metadata.resumeFileName) 
        skillValues.workExperience = response.data[0].profile_metadata.workExperience;
        skillValues.jobRoles = response.data[0].profile_metadata.jobRoles;
        skillValues.techStack = response.data[0].profile_metadata.techStack;
        setSkillValues({ ...skillValues })

        availablity.workType = response.data[0].profile_metadata.workType;
        availablity.contractType = response.data[0].profile_metadata.contractType;
        setAvailablity({...availablity})
      }
      // if (flag && response.data.length === 0) {
      //   updateSignupDetails(values)
      // }
    })
  }



  return (
    <section className={Styles.profileWrapper}>
      <div className={Styles.header}>
        <img src={ellowLogo} alt="ellow.io" />
        <div className={Styles.profileStepper}>
          <StepperDefault items={items} value={step} />
        </div>
        <div className={Styles.emptySpace}></div>
      </div>
      <div className="container">
        
        <div className={Styles.profileStepperInfo}>
            <p>
              Thank you for registering with us. Your journey to success begins now!
              <br/>
              Please provide some basic details to get started.
            </p>
          </div>
        <div className={Styles.profileSteps}>
          <div className={Styles.profileStepForm}>
            {step === 0 && <BasicDetails loginId={loginId ? loginId : googleId} ClickHandler={handleSubmit} Back={Back} defaultValues={profileValues} />}
            {step === 1 && <Resume  loginId={loginId ? loginId : googleId}  updateStepper={updateStepper} resume={resume} Back={Back}/>}
            {step === 2 && <SkillDetails loginId={loginId ? loginId : googleId} OnSubmit={handleSubmit} defaultValues={skillValues} Back={Back} />}
            {step === 3 && <AvailablityDetails loginId={loginId ? loginId : googleId} defaultValues={availablity} Back={Back} />}
          </div>
          <div className={Styles.profileStepSlider}>
            <Testimonial />
          </div>
        </div>
      </div>
    </section>
  );
}

export default BasicProfile;